/**
 * AI model display names for UI progress messages.
 * Keep in sync with backend/src/config/aiModels.ts MODEL_DISPLAY_NAMES and *_WORKFLOW_STAGES.
 */

export const MODEL_DISPLAY_NAMES = {
  claudeSonnet: 'Claude Sonnet 4.6',
  claudeOpus: 'Claude Opus 4.8',
  gptFlagship: 'GPT-5.5',
  gptPro: 'GPT-5.5 Pro',
  gptNano: 'GPT-5.4 Nano',
  gptMini: 'GPT-5.4 Mini',
  gptImage: 'GPT-Image-2',
  geminiFlash: 'Gemini 3.5 Flash',
  geminiFlashImage: 'Nano Banana 2',
  geminiProImage: 'Nano Banana Pro',
  deepResearchO3: 'OpenAI o3 Deep Research',
  deepResearchO4Mini: 'OpenAI o4-mini Deep Research',
} as const;

/** Fallback rotation while Blog Creator jobs poll (backend sends live messages when available). */
export const BLOG_CREATOR_WORKFLOW_STAGES = [
  'Extracting content from top search results with Firecrawl...',
  `Performing ${MODEL_DISPLAY_NAMES.deepResearchO3}...`,
  `Analyzing gaps with ${MODEL_DISPLAY_NAMES.gptFlagship}...`,
  `Generating optimized article with ${MODEL_DISPLAY_NAMES.claudeSonnet}...`,
  'Almost done...',
] as const;

export const TOPICAL_AGENT_PAGE_DESCRIPTION =
  `Generate topical authority articles with ${MODEL_DISPLAY_NAMES.gptFlagship} web research and ${MODEL_DISPLAY_NAMES.claudeSonnet} content generation`;

/** Idle/active placeholders in Blog Creator workflow detail panels (sync with backend JOB_POLL_MESSAGES). */
export const BLOG_CREATOR_STAGE_PLACEHOLDERS = {
  deepResearchActive: `🧠 Performing ${MODEL_DISPLAY_NAMES.deepResearchO3}...`,
  deepResearchIdle: `Performing ${MODEL_DISPLAY_NAMES.deepResearchO3}...`,
  gapAnalysisActive: `📊 Analyzing content gaps with ${MODEL_DISPLAY_NAMES.gptFlagship}...`,
  gapAnalysisIdle: `Analyzing gaps with ${MODEL_DISPLAY_NAMES.gptFlagship}...`,
  contentActive: `✨ Generating article with ${MODEL_DISPLAY_NAMES.claudeSonnet}...`,
  contentIdle: `Generating optimized article with ${MODEL_DISPLAY_NAMES.claudeSonnet}...`,
} as const;
